import 'regenerator-runtime/runtime'
import amazingScroll from './modules/amazingScroll'
import amazingScrollSlider from './modules/amazingScrollSlider'
import magnificPopupTranslation from './modules/magnificPopupTranslation'
import scrollToElement from './modules/scrollToElement'
import numberCounter from './modules/counter'
import fixedNavbar from './modules/fixedNavbar'
import scalevideo from './modules/scaleVideo'
// import imageSlider from './modules/imageSlider'

var animationList = {
	'fade-top': 'top:-100px->0; transition:all 0s->all 1.2s; opacity:0->1;',
	'fade-right': 'opacity: 0->1; right:-150px->0; transition:all 0s->all 1.2s',
	'fade-bottom': 'bottom:-100px->0; transition:all 1.2s; opacity:0->1;',
	'fade-left': 'opacity: 0->1; left:-150px->0; transition:all 0s->all 1.2s',
	'fade-left-top': 'opacity: 0->1; left:-50px->0; top:-50px->0; transition:all 0s->all 1.2s',
	'fade-left-bottom': 'opacity: 0->1; left:-50px->0; bottom:-50px->0; transition:all 0s->all 1.2s',
	'opacity': 'opacity: 0->1; transition:opacity 1.2s, transform .2s ',
	'enlarge': 'transform:scale(0.5)->scale(1); opacity: 0->1; transition:all .8s',
	'shrink': 'transform:scale(1)->scale(0.5); opacity: 0->1; transition:all 0s->all 1.2s',
	'rotate': 'transform:scale(0) rotate(-720deg)->scale(1) rotate(0deg); opacity: 0->1; transition:all 0s->all 1.2s',
	'show-bottom': 'bottom:-30px->0; transition:bottom 1.2s, opacity 1.2s; opacity:0->1'

}

document.addEventListener('DOMContentLoaded', function () {
	if (window.innerWidth >= 1200) {
		window.animate = amazingScroll({
			start: {
				visibleAfterLoading: true,
				waitForScroll: {
					on: false,
					ratio: 0
				}
			},
			animation: animationList
		})
	}

	const selectors = ['.slidersukcesu']
	selectors.forEach(selector => {
		amazingScrollSlider(selector, animationList)
		$(selector).carousel({
			pause: false
		})
	})

	magnificPopupTranslation()
	scrollToElement(document.querySelector('nav.navbar').offsetHeight)
	numberCounter()

	fixedNavbar()

	scalevideo();
	window.addEventListener('resize', scalevideo)

	magnificPopupTranslation()
    $('.gallery-animation').magnificPopup({
        delegate: 'a',
        type: 'image',
        gallery: {
            enabled: true,
            preload: [0, 4]
        }
    })

	// window.slider = new imageSlider('querySelector', 2000)
})

// Wyłączanie linków - usunąć przed zakończeniem prac nad stroną

// document.addEventListener('DOMContentLoaded', function () {
// 	[...document.querySelectorAll('a:not([href*="#"])')]
// // 		.filter(e => !e.dataset.lightbox)
// 		.forEach(el => el.setAttribute('href', '#!'))
// })



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/script.js